import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { afipUpload, getAfips, afipDelete } from "./modules/actions";
import Afip from "./View";

const mapStateToProps = (state) => ({
  afips: state.afipsReducer.afips,
  isUploading: state.afipsReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      afipUpload,
      getAfips,
      afipDelete,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Afip);
